import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { TranslationService } from 'app/core/internationalization/translation.service';
import { RouterService } from 'app/core/navigation';
import { LocalizedToasterService } from 'app/core/toaster/localized-toaster.service';
import { InputTypes } from 'app/shared/enums/input-types.enum';
import { ValidationMessages } from 'app/shared/models/validation-messages.model';
import { MergeAccountDataService } from 'app/shared/services/merge-account-data-service';
import { TEACHERS_ROUTE } from 'app/teachers/teachers-routing.constant';

@Component({
  selector: 'kh-merge-teacher-form',
  styleUrls: ['./merge-teacher-form.component.less'],
  templateUrl: './merge-teacher-form.component.html',
  standalone: false
})
export class MergeTeacherFormComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private readonly _translationService = inject(TranslationService);
  private readonly mergeAccountDataService = inject(MergeAccountDataService);
  private readonly routerService = inject(RouterService);
  private readonly toaster = inject(LocalizedToasterService);
  private readonly location = inject(Location);

  public inputTypes = InputTypes;
  public credentialsForm!: FormGroup;
  public credentialsFormFields = {
    email: 'email',
    password: 'password'
  };

  public validationMessages: ValidationMessages = {
    required: this._translationService.instant('MERGE_TEACHER_FORM.THIS_FIELD_IS_REQUIRED'),
    invalid: this._translationService.instant('MERGE_TEACHER_FORM.INVALID_CREDENTIALS')
  };

  public ngOnInit(): void {
    this.credentialsForm = this.getCredentialsForm();
  }

  public getCredentialsForm(): FormGroup {
    return this.formBuilder.group({
      [this.credentialsFormFields.password]: this.formBuilder.control(undefined, Validators.required),
      [this.credentialsFormFields.email]: this.formBuilder.control(undefined, [Validators.required, Validators.email])
    });
  }

  public continue(): void {
    if (this.credentialsForm.valid) {
      const email = this.credentialsForm.value.email;
      const password = this.credentialsForm.value.password;
      this.mergeAccountDataService
        .validateMergeCandidate(email, password)
        .pipe(
          tap((res) => {
            if (res.canMerge) {
              this.routerService.navigate(TEACHERS_ROUTE.MERGE_ACCOUNT_SEND_EMAIL.route(),
                { queryParams: TEACHERS_ROUTE.MERGE_ACCOUNT_SEND_EMAIL.queryParams(res.displayName, res.email) }).catch((error: unknown) => console.error(error));
            }
            else {
              this.toaster.error('MERGE_TEACHER_FORM.ACCOUNT_CANNOT_BE_MERGED');
              this.credentialsForm.reset();
            }
          }),
          catchError((error) => {
            if (error.error.Errors.includes('Invalid credentials.')) {
              this.toaster.error(this.validationMessages.invalid);
            }

            return EMPTY;
          })
        ).subscribe();
    }
  }

  public backButton(): void {
    this.location.back();
  }
}
